<template lang="pug">
    div.news-wrapper
        section
            div.container.has-text-centered
                h1.news-title.is-size-35.is-uppercase {{ $t('page_10.title') }}
                p {{ $t('page_10.subtitle') }}
                div.news-separator.is-separator

        section.news-list
            div.container
                div.columns.is-multiline.is-marginless
                    div.column.is-half(v-for="n in news")
                        router-link(:to="'/news' + n.url")
                            article-preview(:article="n")
</template>

<script>
import ArticlePreview from '@/components/news-article-preview'

export default {
    name: 'news',
    components: { ArticlePreview },
    data () {
        return {
            news: []
        }
    },
    created () {
        this.news = this.$t('page_10.articles')
    }
}
</script>

<style lang="stylus" scoped>
.news-wrapper
    padding-top 200px
    padding-bottom 125px

.news-title
    margin-bottom 1rem

.news-separator
    margin 50px 0

</style>
